const n = async (e) => {
  const t = await e.text();
  if (t.trim().length !== 0)
    return JSON.parse(t);
};
export {
  n as readJsonResponse
};
